export enum AllowedAdminUsernames {
  ANAS = 'anas',
  ADMIN = 'admin',
  ABDULKARIM = 'abdulkarim',
  RAKAN = 'rakan@recyclee.io',
}

export enum ReadOnlyAdminUsernames {}

export interface LoginRequest {
    username?: string;
    phone?: string;
    password: string;
}

export interface LoginResponse {
    access_token: string;
    refresh_token: string;
}

export interface RefreshTokenRequest {
    refresh_token: string;
}

export interface RegisterRequest {
    username: string;
    password: string;
    password_confirm: string;
    phone?: string | null;
    data: UserData;
}

export interface UserData {
    permissions?: string[] | Record<string, string[]>;
    sites?: Record<string, string[]> | null;
    role?: 'recycler' | 'waste_outlet' | 'admin' | string;
    onesignal_player_id?: string;
    [key: string]: unknown;
}

export interface UserSchema {
    id?: string;
    sub: string;
    username: string;
    email?: string;
    data?: UserData;
    created_at?: string;
    updated_at?: string;
    exp?: number;
    iat?: number;
}

export interface UpdateUserRequest {
    username?: string | null;
    data?: Partial<UserData> | null;
}

export interface ForgotPasswordRequest {
    username: string;
    platform: "OPS" | "ZERO" | "360" | "ADMIN" | "MARKET";
}

export interface ResetPasswordRequest {
    token: string;
    new_password: string;
    new_password_confirm: string;
}

/** JWT access token payload — permissions at root after PR2 migration. */
export interface AuthTokenPayload {
    sub: string;
    username: string;
    typ: string;
    exp: number;
    iat: number;
    permissions: string[] | Record<string, string[]>;
    platform_permissions?: string[];
    sites?: Record<string, string[]>;
}
